/** Harmonate rebrand design tokens — Conductor V2 App UI Refresh */

/** Mix solid fill with white at the given opacity (design: hover = 80% fill). */
const mixWithWhite = (hex, fillOpacity = 0.8) => {
  const raw = hex.replace('#', '');
  const n = parseInt(raw.length === 3 ? raw.split('').map((c) => c + c).join('') : raw, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const mix = (c) => Math.round(c * fillOpacity + 255 * (1 - fillOpacity));
  return `#${[mix(r), mix(g), mix(b)].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
};

export const harmonateTokens = {
  darkBlue: '#013062',
  blue: '#2EA6A0',
  green: '#026B1D',
  red: '#EF3F3F',
  /** Warning alerts / WARN chips */
  orange: '#ff751f',
  secondaryTab: '#CEE5FF',
  /** Body / labels / headings on white, grey, or light-grey surfaces */
  text: '#000000',
  fadedText: '#000000',
  drawerBg: '#E8E8E8',
  line: '#C4C4C4',
  listBg: '#F9F9F9',
  white: '#FFFFFF',
  /** App page / shell background (solid). Login keeps fadeGradient. */
  pageBg: '#013062',
  fadeGradient: 'linear-gradient(90deg, #2EA6A0 0%, #013062 100%)',
  buttonShadow: '4px 4px 8px rgba(0, 0, 0, 0.25)',
  cardShadow: '4px 4px 12px rgba(0, 0, 0, 0.25)',
  buttonRadius: '20px',
  cardRadius: '20px',
  fieldRadius: '20px',
};

/** Hover fills — 80% brand color over white so label stays fully opaque */
harmonateTokens.greenHover = mixWithWhite(harmonateTokens.green);
harmonateTokens.redHover = mixWithWhite(harmonateTokens.red);
harmonateTokens.orangeHover = mixWithWhite(harmonateTokens.orange);
harmonateTokens.blueHover = mixWithWhite(harmonateTokens.blue);
harmonateTokens.darkBlueHover = mixWithWhite(harmonateTokens.darkBlue);
harmonateTokens.textHover = mixWithWhite(harmonateTokens.text);

export default harmonateTokens;
